import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import _debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import { useEventListener } from '@ovpn-ui/utils';
/**
 * returns height & width of the ref element, updates onResize.
 * @param elementRef HTMLElement ref
 */
export const useElementSize = elementRef => {
  const [size, setSize] = useState({
    height: undefined,
    width: undefined
  });
  const sizeRef = useRef({
    height: undefined,
    width: undefined
  });
  useEffect(() => {
    sizeRef.current = size;
  }, [size]);
  const updateSize = useCallback(() => {
    if (elementRef && elementRef.current) {
      const {
        width: boundingWidth,
        height: boundingHeight
      } = elementRef.current.getBoundingClientRect();
      const newSize = {};
      const currentSize = sizeRef.current;
      if (boundingHeight !== currentSize.height) {
        newSize.height = boundingHeight;
      }
      if (boundingWidth !== currentSize.width) {
        newSize.width = boundingWidth;
      }
      if (!isEmpty(newSize)) {
        setSize({
          ...currentSize,
          ...newSize
        });
      }
    }
  }, [elementRef]);
  const debouncedResize = useMemo(() => _debounce(updateSize, 500), [updateSize]);
  useEffect(updateSize, [updateSize]);
  useEventListener('resize', debouncedResize);
  return {
    height: size.height,
    width: size.width
  };
};